import { CONTENT_WIDTH } from "@/enums";
import { refType } from "@/propTypes";
import { Button, Col } from "antd";
import { bool, func, string } from "prop-types";

const CancelSaveDraftAndSubmitActions = ({
  formRef,
  cancelButtonOnClick,
  cancelButtonText,
  noValidateButtonOnClick,
  noValidateButtonText,
  noValidateIsSaving,
  isSubmitting,
  submitButtonText,
}) => (
  <>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-cancel"
        onClick={() => cancelButtonOnClick()}
        block
      >
        {cancelButtonText}
      </Button>
    </Col>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-no-validate"
        type="primary"
        onClick={() =>
          noValidateButtonOnClick(formRef.current.getFieldsValue(true), formRef)
        }
        loading={noValidateIsSaving}
        disabled={isSubmitting}
        block
        formNoValidate={true}
      >
        {noValidateButtonText}
      </Button>
    </Col>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-submit"
        type="primary"
        onClick={() => formRef.current.submit()}
        loading={isSubmitting}
        disabled={noValidateIsSaving}
        block
      >
        {submitButtonText}
      </Button>
    </Col>
  </>
);

CancelSaveDraftAndSubmitActions.propTypes = {
  formRef: refType.isRequired,
  cancelButtonOnClick: func.isRequired,
  cancelButtonText: string.isRequired,
  noValidateButtonOnClick: func.isRequired,
  noValidateButtonText: string.isRequired,
  submitButtonText: string.isRequired,
  noValidateIsSaving: bool.isRequired,
  isSubmitting: bool.isRequired,
};

const CancelAndSubmitActions = ({
  formRef,
  cancelButtonOnClick,
  cancelButtonText,
  isSubmitting,
  submitButtonText,
}) => (
  <>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-cancel"
        onClick={() => cancelButtonOnClick()}
        block
      >
        {cancelButtonText}
      </Button>
    </Col>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-submit"
        type="primary"
        onClick={() => formRef.current.submit()}
        loading={isSubmitting}
        block
      >
        {submitButtonText}
      </Button>
    </Col>
  </>
);

CancelAndSubmitActions.propTypes = {
  formRef: refType.isRequired,
  cancelButtonOnClick: func.isRequired,
  cancelButtonText: string.isRequired,
  isSubmitting: bool.isRequired,
  submitButtonText: string.isRequired,
};

const SubmitAction = ({
  formRef,
  isSubmitting,
  submitButtonText,
  disabled,
}) => (
  <>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="dynamic-form-submit"
        type="primary"
        onClick={() => formRef.current.submit()}
        loading={isSubmitting}
        disabled={disabled}
        block
      >
        {submitButtonText}
      </Button>
    </Col>
  </>
);

SubmitAction.propTypes = {
  disabled: bool.isRequired,
  formRef: refType.isRequired,
  isSubmitting: bool.isRequired,
  submitButtonText: string.isRequired,
};

export {
  CancelSaveDraftAndSubmitActions,
  CancelAndSubmitActions,
  SubmitAction,
};
